//状态
//基础文字按钮
//组件默认设置提示文字


export default {
  service_error: '服务器开小差了',
  '删除': '删除',
  '暂无数据': '暂无数据',
  '是': '是',
  '否': '否',
  "下一步": "下一步",
  "上一步": "上一步",
  "提交订单": "提交订单",
  "展位号": "展位号",
  "申请时间": "申请时间",
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/base/base.js